const CHANGE_CHANNEL = "CHANGE_CHANNEL"
const ADD_BRANDED_CONTENT = "ADD_BRANDED_CONTENT"
const UPDATE_RESULTS = "UPDATE_RESULTS"
const CLEAR_RESULTS = "CLEAR_RESULTS"
const UPDATE_QUERY = "UPDATE_QUERY"
const TOGGLE_EXPANDED = "TOGGLE_EXPANDED"
const TOGGLE_LOGO_VISIBLE = "TOGGLE_LOGO_VISIBLE"
const SHOW_MODAL_WITH_MESSAGE = "SHOW_MODAL_WITH_MESSAGE"
const HIDE_MODAL = "HIDE_MODAL"
const TOGGLE_SEARCH_VISIBLE = "TOGGLE_SEARCH_VISIBLE"

export const changeChannel = (channel) => {
  return {
    type: CHANGE_CHANNEL,
    payload: channel
  }
}

export const addBrandedContent = (posts) => {
  return {
    type: ADD_BRANDED_CONTENT,
    payload: posts
  }
}

export const updateResults = (results) => {
  return {
    type: UPDATE_RESULTS,
    payload: results
  }
}

export const clearResults = (results) => {
  return {
    type: CLEAR_RESULTS,
    payload: results
  }
}

export const updateQuery = (value) => {
  return {
    type: UPDATE_QUERY,
    payload: value
  }
}

export const toggleExpanded = (payload) => {
  return {
    type: TOGGLE_EXPANDED,
    payload: payload
  }
}

export const toggleLogoVisible = (payload) => {
  return {
    type: TOGGLE_LOGO_VISIBLE,
    payload: payload
  }
}

export const toggleSearchVisible = (payload) => {
  return {
    type: TOGGLE_SEARCH_VISIBLE,
    payload: payload
  }
}

export const showModalWithMessage = (message) => {
  return {
    type: SHOW_MODAL_WITH_MESSAGE,
    payload: message
  }
}

export const hideModal = () => {
  return {
    type: HIDE_MODAL
  }
}